import React from "react";

const Contact = ({ Message: msg }) => (
  <section
    id="contact"
    style={{ backgroundImage: "Url(images/section-background-02.jpg)" }}
  >
    <div className="container">
      <p>{msg.contactDesc01}</p>
      <p>
        {msg.contactDesc02}{" "}
        <a href={"mailto:" + msg.contactEmail} className="link">
          {msg.contactEmail}
        </a>
      </p>
      <a href={"mailto:" + msg.contactEmail} className="btn btn-primary">
        {msg.contactBtn}
      </a>
    </div>
  </section>
);

export default Contact;
